import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

let ids = new Set();
let loaded = false;
const subs = new Set();

const load = () => {
  if (loaded) return;
  loaded = true;
  api.get("/birthdays/ids").then(({ data }) => { ids = new Set(data); subs.forEach((f) => f()); }).catch(() => { loaded = false; });
};

const subscribe = (f) => { subs.add(f); load(); return () => subs.delete(f); };

export const useIsBirthday = (id) => useSyncExternalStore(subscribe, () => Boolean(id) && ids.has(id));
